class SmartListsData {

    constructor() {

        this._draggingCarousel = false;

        this._LIST_VIEW_ID = 1;
        this._CARD_WIDE_ID = 2;
        this._CARD_TALL_ID = 3;
        this._CARD_SQUARE_ID = 4;
        this._CARD_ART_ID = 5;
        this._COVER_ID = 6;
        this._WALL_ID = 7;
        this._CARD_ART_PROGRESS_ID = 8;

        this._LIST_VIEW = "LIST";
        this._WALL_VIEW = "WALL";
        this._SPECIAL_POLL_VIEW = "SPECIAL_POLL";
        this._SPECIAL_GAME_VIEW = "SPECIAL_GAME";
        this._SPECIAL_TASK_VIEW = "SPECIAL_TASK";

        this._SPECIAL_TEST_VIEW = "SPECIAL_TEST";
        this._CARD_SQUARE_VIEW = "CARD_SQUARE";
        this._CARD_TALL_VIEW = "CARD_TALL";
        this._CARD_WIDE_VIEW = "CARD_WIDE";
        this._CARD_ART_VIEW = "CARD_ART";
        this._HIGHLIGHT_VIEW = "HIGHLIGHT";
        this._COVER_VIEW = "COVER";

        this._LIST_TEMPLATE = "SLContentList";
        this._WALL_TEMPLATE = "SLContentWall";
        this._SPECIAL_POLL_TEMPLATE = "SLContentSpecialPoll";
        this._SPECIAL_GAME_TEMPLATE = "SLContentSpecialGame";
        this._SPECIAL_TASK_TEMPLATE = "SLContentSpecialTask";
        this._SPECIAL_TEST_TEMPLATE = "SLContentSpecialTest";
        this._CARD_SQUARE_TEMPLATE = "SLContentCardSquare";
        this._CARD_TALL_TEMPLATE = "SLContentCardTall";
        this._CARD_WIDE_TEMPLATE = "SLContentCardWide";
        this._CARD_ART_TEMPLATE = "SLContentCardArt";
        this._HIGHLIGHT_TEMPLATE = "SLContentHighlight";
        this._COVER_TEMPLATE = "SLContentCover";

    }

    // Funcion que devuelve un diccionario relacionando las ids de las posibles cover con sus nombres (En backend se usan ids pero en frontend nombres)
    getSmartListsDictIds() {

        const smartListDict = {};

        smartListDict[this._LIST_VIEW_ID] = this._LIST_VIEW;
        smartListDict[this._CARD_WIDE_ID] = this._CARD_WIDE_VIEW;
        smartListDict[this._CARD_TALL_ID] = this._CARD_TALL_VIEW;
        smartListDict[this._CARD_SQUARE_ID] = this._CARD_SQUARE_VIEW;
        smartListDict[this._CARD_ART_ID] = this._CARD_ART_VIEW;
        smartListDict[this._COVER_ID] = this._COVER_VIEW;
        smartListDict[this._WALL_ID] = this._WALL_VIEW;
        smartListDict[this._CARD_ART_PROGRESS_ID] = this._CARD_ART_VIEW; // _CARD_ART_PROGRESS_ID con id 8 es para los casos de CARD_ART con el progreso a la izquierda, backend lo trata como nueva cover pero frontend como propiedad de la CARD_ART

        return smartListDict;

    }

    getSmartListsDictViews() {

        const smartListsDict = {};

        smartListsDict[this._LIST_VIEW] = this._LIST_TEMPLATE;
        smartListsDict[this._WALL_VIEW] = this._WALL_TEMPLATE;
        smartListsDict[this._SPECIAL_POLL_VIEW] = this._SPECIAL_POLL_TEMPLATE;
        smartListsDict[this._SPECIAL_GAME_VIEW] = this._SPECIAL_GAME_TEMPLATE;
        smartListsDict[this._SPECIAL_TASK_VIEW] = this._SPECIAL_TASK_TEMPLATE;
        smartListsDict[this._SPECIAL_TEST_VIEW] = this._SPECIAL_TEST_TEMPLATE;
        smartListsDict[this._CARD_SQUARE_VIEW] = this._CARD_SQUARE_TEMPLATE;
        smartListsDict[this._CARD_TALL_VIEW] = this._CARD_TALL_TEMPLATE;
        smartListsDict[this._CARD_WIDE_VIEW] = this._CARD_WIDE_TEMPLATE;
        smartListsDict[this._CARD_ART_VIEW] = this._CARD_ART_TEMPLATE;
        smartListsDict[this._HIGHLIGHT_VIEW] = this._HIGHLIGHT_TEMPLATE;
        smartListsDict[this._COVER_VIEW] = this._COVER_TEMPLATE;

        return smartListsDict;

    }

    getDraggingCarousel() {
        return this._draggingCarousel;
    }

    setDraggingCarousel(dragging) {
        this._draggingCarousel = dragging;
    }

}